var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalktoAnExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2973 13.0661C13.0059 12.2657 12.5058 11.537 11.8371 10.9386C10.7095 9.93337 9.12399 9.32848 7.30955 9.32848C3.70409 9.32848 1 11.7162 1 14.8998V18.8794H10.0136M10.915 15.5557L14.6917 18.0835L20.83 10.9203M7.30955 9.32848C8.50483 9.32848 9.65115 8.9092 10.4963 8.16289C11.3415 7.41658 11.8164 6.40437 11.8164 5.34893C11.8164 4.29349 11.3415 3.28128 10.4963 2.53497C9.65115 1.78866 8.50483 1.36938 7.30955 1.36938C6.11426 1.36938 4.96794 1.78866 4.12274 2.53497C3.27755 3.28128 2.80273 4.29349 2.80273 5.34893C2.80273 6.40437 3.27755 7.41658 4.12274 8.16289C4.96794 8.9092 6.11426 9.32848 7.30955 9.32848V9.32848Z",
    stroke: "#4B5768",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalktoAnExpert);
export default __webpack_public_path__ + "static/media/TalktoAnExpert.3f96bf0379512a3661f1df6bdf4ed37d.svg";
export { ForwardRef as ReactComponent };